// extracted by mini-css-extract-plugin
export default {"card":"j5-z"};